import React from 'react';

import styled, { css } from 'styled-components';
import { Icon } from 'fpay-ui';
import { useTranslation } from 'react-i18next';

import { getEnv } from '@config';
import CardDescription from './CardDescription';
import { breakpoint } from '../../../constants/styles';

import Text from '../../Text';

const { publicPath } = getEnv();

const Card = styled.div`
  cursor: pointer;
  position: relative;
  width: 100%;
  height: 424px;
  border-radius: 6px;
  background-color: var(--gray200);
  margin-right: 16px;
  padding: 24px 24px 40px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }) => theme.breakpoint('md')} {
    max-width: calc(33% - 9px);
    height: 418px;
    padding: 32px 32px 24px;
  }
`;

const Title = styled(Text)`
  margin-bottom: 26px;
`;

const Checkbox = styled.div`
  position: absolute;
  right: 21px;
  top: 21px;
  object-fit: contain;
`;

const NotSelected = styled.div(
  ({ theme }) => css`
    width: 22px;
    height: 22px;
    margin: 5px;

    border: 2px solid ${theme.colors.gbrand500};
    border-radius: 4px;
  `
);

const Selected = styled.img`
  width: 32px !important;
  height: 32px;
`;

const Image = styled.div`
  width: 76px;
  height: 76px;
  background-color: #fff;
  border-radius: 50%;
  margin: 0 auto;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${breakpoint('medium')`
    margin-bottom: 18px;
  `}
  & img {
    position: absolute;
    top: 20px;
    left: 25px;
  }
`;

export default function UserCard({ card, handleClick, selection, htmlIdCard = 'unidentified-id' }) {
  const { t } = useTranslation();

  return (
    <Card card={card} selection={selection} onClick={() => handleClick(card)} id={htmlIdCard}>
      <Checkbox>
        {card.name === selection ? (
          <Selected src={`${publicPath}/selectedRole.svg`} />
        ) : (
          <NotSelected />
        )}
      </Checkbox>
      <Image>
        <Icon icon={`ic-${card.image.toLowerCase()}`} width="24" height="24" />
      </Image>
      <Title type="Subtitle-1-w500" color="gray800">
        {t(card.title)}
      </Title>
      <CardDescription
        id={`description-${card.title}`}
        icon="ic-check-24.svg"
        listDescriptions={card.listDescriptions}
      />
    </Card>
  );
}
